/**
 * Adds optional classes to the given default className
 * @param defaultClassName The default className to use
 * @param extraClasses Extra classes to apply
 * @returns A string with the new className
 */
export const addOptionalClasses = (defaultClassName: string, extraClasses: string[] | null): string => {
  if (!extraClasses) {
    return defaultClassName;
  }

  const nonEmptyClassNames = [defaultClassName, ...extraClasses].filter((className => !!className));
  const joined = nonEmptyClassNames.join(' ');
  return joined;
};

/**
 * Adds an extra class if condition is true
 * @param defaultClassName The default className to use
 * @param extraClass Extra class to apply when condtion is true
 * @param condition The condition
 * @returns A string with the new className
 */
export const addConditionalClass = (defaultClassName: string, extraClass: string, condition: boolean) => {
  return addOptionalClasses(defaultClassName, condition ? [extraClass] : null);
};

/**
 * Adds a modifier class if condition is true
 * @param defaultClassName The default className to use
 * @param modifierClass Extra modifier class to apply when condtion is true
 * @param condition The condition
 * 
 * @example
 * // 'my-class my-class--large'
 * const className = addConditionalModifierClass('my-class', 'large', isLarge);
 */
export const addConditionalModifierClass = (defaultClassName: string, modifierClass: string, condition: boolean) => {
  return addConditionalClass(defaultClassName, `${defaultClassName}--${modifierClass}`, condition);
};
